<template>
  <div class="addresses">
    <div class="row">
      <div class="col">
        <div class="custom-control custom-checkbox input-group-lg">
          <input
            type="checkbox"
            class="custom-control-input"
            id="homeDelivery"
            v-model="homeDelivery"
            @input="changeHomeDelivery()"
          />
          <label class="custom-control-label" for="homeDelivery">
            <h5>Envío a domicilio</h5>
          </label>
        </div>
      </div>
    </div>
    <div v-if="homeDelivery">
      <div class="row">
        <div class="col">
          <Dates :dates="dates" :selected="dateHour" @selectedDate="updateDate" />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col-12">
              <div class="select-address mb-3">
                <h5 class="mb-2">Dirección</h5>
                <button class="btn btn-primary" type="button" @click="showModalNewAddress()">
                  Agregar
                </button>
              </div>
              <ModalAddress :typeModal="typeModal" :deliveryZones="deliveryZones" />
            </div>
          </div>
          <div class="row" v-if="showCardAddress">
            <div class="col">
              <CardAddress :address="address" />
            </div>
          </div>
          <div v-else>
            <span>Agregar una dirección</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../api';
export default {
  data() {
    return {
      dates: [],
      dateHour: {},
      deliveryZones: '',
      homeDelivery: false,
      dateTime: ''
    };
  },
  watch: {
    dateHour() {
      if (this.homeDelivery) {
        this.$store.dispatch('updateDateTimeDelivery', this.dateHour);
        const address = this.address ? this.address : {};
        this.$store.dispatch('updateAddressDelivery', address);
      }
    },
    homeDelivery(value) {
      if (!value) {
        this.$store.dispatch('updateAddressDelivery', {});
        this.$store.dispatch('updateDateTimeDelivery', {});
      }
    },
    address(value) {
      this.$store.dispatch('updateAddressDelivery', value);
    }
  },
  computed: {
    auth() {
      return this.$store.state.auth;
    },
    productsMeta() {
      return this.$store.getters.cartProductsMeta;
    },
    showCardAddress() {
      return this.$store.getters.getAddress ? true : false;
    },
    typeModal() {
      return this.$store.getters.getTypeActionModalAddress;
    },
    address() {
      return this.$store.getters.getAddress;
    },
    isHomeDelivery() {
      return this.$store.getters.isHomeDelivery;
    },
    delivery() {
      return this.$store.getters.delivery;
    }
  },
  methods: {
    async getDeliveries() {
      const payload = {
        session: this.auth.token,
        storeId: this.productsMeta.storeId
      };
      try {
        const data = await api.getDeliveriesDates(payload);
        this.dates = data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getDeliveryZones() {
      const storeId = this.productsMeta.storeId;
      try {
        const { data } = await api.getDeliveryZones({ storeId });
        this.deliveryZones = data.merchandiseDeliveryZones;
        this.$store.dispatch('updateZones', this.deliveryZones.data);
      } catch (error) {
        console.log(error);
      }
    },
    changeHomeDelivery() {
      this.$store.commit('changeIsHomeDelivery');
    },
    showModalNewAddress() {
      this.$store.commit('setTypeActionModalAddress', 'add');
      this.$store.commit('setShowModalNewAddress');
    },
    getAddress() {
      const session = this.auth.token;
      this.$store.dispatch('getUserAddresses', session);
    },
    updateDate(value) {
      this.dateHour = value;
      this.$store.dispatch('updateDateTimeDelivery', value);
    },
    setDefaultValues() {
      this.homeDelivery = this.isHomeDelivery;
      this.dateHour = this.delivery.dateTime;
    }
  },
  mounted() {
    this.setDefaultValues();
    this.getDeliveries();
    this.getDeliveryZones();
    this.getAddress();
  }
};
</script>
<style lang="scss">
.select-address {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
